module.exports = __webpack_public_path__ + "static/media/15.84f5909a.jpg";